import React, { Component } from 'react'
import '../styles/Dashboard.css'
import Indicators from './Indicators'
import NetIncome from './NetIncome'
import PieRegisteredFarmers from './PieRegisteredFarmers'
import PieAEDSteps from './PieAEDSteps'
// import PresentGranteeBarChart from './PresentGranteeBarChart'
import DatePicker from '../widgets/DatePicker'

class Dashboard extends Component
{
	render() {
		const view = <div id="dashboard">
			<div id="generate-filter">
				<div>From</div>
				<DatePicker />
				<div>to</div>
				<DatePicker />
				<button>GENERATE</button>
			</div>
			<div id="dash-chart">
				<div id="dc-indicators"><Indicators /></div>
				<div id="dc-income"><NetIncome /></div>
				<div id="dc-farmers"><PieRegisteredFarmers /></div>
				<div id="dc-aed"><PieAEDSteps /></div>
			</div>
		</div>
		return(view)
	}
}

export default Dashboard
